module.exports = __webpack_public_path__ + "img/image02@2x.2f613a97.webp";